import { useCallback } from "react";
import { useToggle } from "@react-md/utils";
/**
 * @internal
 */
export function useFocusState(_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur;
    var _b = useToggle(false), focused = _b[0], setFocused = _b[1], setBlurred = _b[2];
    var handleFocus = useCallback(function (event) {
        if (onFocus) {
            onFocus(event);
        }
        setFocused();
    }, [setFocused, onFocus]);
    var handleBlur = useCallback(function (event) {
        if (onBlur) {
            onBlur(event);
        }
        setBlurred();
    }, [setBlurred, onBlur]);
    return [focused, handleFocus, handleBlur];
}
//# sourceMappingURL=useFocusState.js.map